import React from 'react';

import { Tag, Tooltip, Space } from 'antd';

interface ITagsProps {
    warehouseCode: string | undefined;
}
const TransitWarehouseTag = (props: ITagsProps) => {
    const { warehouseCode } = props;

    if (!warehouseCode) return;

    return (
        <div>
            <Tooltip title='Транзитный склад' color='var(--main-green)'>
                <Tag variant='solid' color='var(--main-green)' style={{ fontWeight: 600 }}>
                    {warehouseCode}
                </Tag>
            </Tooltip>
        </div>
    );
};

export default TransitWarehouseTag;
